module.exports = __webpack_public_path__ + "static/media/cd.b0b418db.svg";